import React from 'react';
import {
  Card,
  CardImage,
  ProductBody,
  ProductName,
  ProductPrice,
} from './productCard.style';
import PropTypes from 'prop-types';
import commaNumber from 'comma-number';

const ProductCard = ({ product, seller }) => {
  return (
    <Card>
      <CardImage>
        <img src={product?.image} />
      </CardImage>
      <ProductName>{product?.name}</ProductName>
      <ProductBody>
        <div className="description">{product?.description?.slice(0, 33)}...</div>
      </ProductBody>

      <ProductPrice>
        <div className="price">
          {' '}
          {seller?.currency?.symbol}
          {commaNumber(product?.price?.value)}
        </div>

        {product.in_stock ? (
          <div className="in_stock">In stock</div>
        ) : (
          <div className="out_stock">Out of stock</div>
        )}
      </ProductPrice>
    </Card>
  );
};

export default ProductCard;

ProductCard.propTypes = {
  product: PropTypes.object.isRequired,
  seller: PropTypes.object.isRequired,
};
